import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { serverIp, toCurrency, pythonApiIp } from '../../../../config/constants.js'


class SendSinglePayroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shirttypebuycost: '',
            sent: false,
        }
    }

    componentDidMount() {
        this.setState({
            shirttypebuycost: this.props.shirttypebuycost
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendPayroll = () => {
        console.log("++++++++:sendPayroll");
        console.log(this.state.shirttypebuycost)
        console.log(this.props.shirttype)
        console.log(this.props.dateNum)

        if (this.state.shirttypebuycost == '') {
            alert("No shirttypebuycost")
        } else if (this.props.shirttype == undefined) {
            alert("No shirttype")
        } else if (this.props.dateNum == undefined) {
            alert("No dateNum")
        } else {
            console.log("sending data..");

            this.setState({ loading: true })

            axios.post(serverIp + 'billing/enterSinglePayRoll', {
                apiKey: "asdffe22",
                shirttypebuycost: this.state.shirttypebuycost,
                shirttype: this.props.shirttype,
                dateSent: this.props.dateNum,
                enteredBy: this.props.user.email
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. payroll saved");

                        this.setState({
                            sent: true
                        })

                        alert(response.data.message);
                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const formUi = !this.state.sent
            ? <div>
                <h4>{this.props.dateString}</h4>

                <Form onSubmit={this.sendPayroll}>

                    <label>{this.props.shirttype}</label>
                    <br />
                    <label>{toCurrency(this.state.shirttypebuycost)}</label>

                    <Form.Input
                        fluid
                        icon='blind'
                        iconPosition='left'
                        placeholder={this.state.shirttypebuycost}
                        type='number'
                        name="shirttypebuycost"
                        value={this.state.shirttypebuycost}
                        onChange={this.handleTextInputChange}
                    />

                    <Button type='submit'>Submit</Button>
                </Form>
            </div>
            : ''

        const alreadySent = this.state.sent
            ? <h4>SENT</h4>
            : ''

        return (<div>
            {formUi}
            {alreadySent}
        </div>);
    }
}

export default SendSinglePayroll;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Payroll_Expenses/SendSinglePayroll.js